import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'skuVenueClosedConfirmationModal.title',
    defaultMessage: 'Pause orders for today?',
  },
  description: {
    id: 'skuVenueClosedConfirmationModal.description',
    defaultMessage: 'Pausing orders will stop new orders for the rest of today. Existing orders will NOT be cancelled.',
  },
  cancel: {
    id: 'skuVenueClosedConfirmationModal.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'skuVenueClosedConfirmationModal.confirm',
    defaultMessage: 'Confirm',
  },
});
